// extracted by mini-css-extract-plugin
export default {"terms":"Terms_terms__jvY7J"};